import React from "react";

import destination_1 from "../../public/wheretogo-sumava/polednik/destination_1.png";
import destination_2 from "../../public/wheretogo-sumava/polednik/destination_2.png";
import destination_3 from "../../public/wheretogo-sumava/polednik/destination_3.png";
import destination_4 from "../../public/wheretogo-sumava/polednik/destination_4.png";
import destination_5 from "../../public/wheretogo-sumava/polednik/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-sumava/polednik/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-sumava/polednik/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-sumava/polednik/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-sumava/polednik/icon_4.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const Polednik = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Poledník</h1>
            <p>
              Na jeho vrcholu stojí bývalý vojenský objekt s věží, která kdysi
              sloužila jako vojenská pozorovatelna a rušička. Dnes je z této
              věže rozhledna (1315 m n. m.). Poledník je též někdy nazýván
              Polední hora.
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__icons--container">
            <div className="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>vstup 30kč</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>rozhledna</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>turistické trasy</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>červen - říjen</p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`destinations__attractions ${darkMode ? "dark" : "light"}`}
      >
        <div className="container">
          <div className="destinations__attractions--container">
            <div className="destinations__attractions--image">
              <img className="destination_1" src={destination_2} alt="" />
              <img className="destination_2" src={destination_3} alt="" />
              <img className="destination_3" src={destination_4} alt="" />
              <img className="destination_4" src={destination_5} alt="" />
            </div>
            <div className="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Nádrž na toku Morávky, byla původně počátkem 50. let
                  připravována v lokalitě u Raškovic, 8 kilometrů níže po
                  proudu.
                </li>
                <li>
                  V roce 1998 byla rozhledna Poledník poprvé otevřena
                  veřejnosti. Na rozhlednu Poledník vede celkem 227 schodů a na
                  samotném vrchu věžě může být maximálně 10 lidí.
                </li>
                <li>
                  Od roku 1998 se mohou turisté těšit z jedinečného výhledu na
                  celou centrální Šumavu a Bavorský les a za dobré viditelnosti
                  zahlédnout i Alpy.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Polednik;
